import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import i18n from "i18next";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng:
      localStorage.getItem("language") ?? (navigator.language.includes("zh") ? "ja" : navigator.language).slice(0, 2),
    fallbackLng: (navigator.language.includes("zh") ? "ja" : navigator.language).slice(0, 2),
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
  });

export default i18n;
